package es.cinfo.tiivii.core.modules.config

/**
 * Global configuration object exposing compilation values
 */
data class CoreBuild(
    val coreConfig: ConfigModel.ViewModel.CoreConfig,
    val envConfig: ConfigModel.ViewModel.EnvConfig
)